import React, { useState } from 'react';
import products from '../../data/products.json';
import Logo from '../Logo';
import Item from './Item';
import Mobile from './Mobile';

const Menu = ({ isProduct = false }) => {
  const [isMenuOpen, setMenuOpen] = useState(false);
  return (
    <div className="bg-indigo-700 print:hidden">
      <div className="max-w-screen-xl px-4 mx-auto sm:px-6 py-4">
        <nav className="relative flex items-center justify-between sm:h-10 md:justify-center">
          <div className="flex items-center flex-1 md:absolute md:inset-y-0 md:left-0">
            <div className="flex items-center justify-between w-full md:w-auto z-10">
              <Logo />
              <div className="-mr-2 flex items-center md:hidden">
                <button
                  type="button"
                  className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 focus:text-gray-500 transition duration-150 ease-in-out"
                  id="main-menu"
                  aria-label="Main menu"
                  aria-haspopup="true"
                  onClick={() => setMenuOpen(true)}
                >
                  <svg
                    className="h-6 w-6"
                    stroke="currentColor"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M4 6h16M4 12h16M4 18h16"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <div className="hidden md:flex md:space-x-10">
            {isProduct ? (
              <>
                <Item link="#features" title="Features" />
                <Item link="#pricing" title="Pricing" />
                <Item link="#faq" title="FAQ" />
              </>
            ) : (
              <>
                <Item link={products.GA01.link} title="Mail Merge" />
                <Item link={products.GA16.link} title="Document Studio" />
              </>
            )}
            <Item link="/#products" title="Products" />
            <Item link="/support" title="Support" />
          </div>
        </nav>
      </div>
      {isMenuOpen && <Mobile isProduct={isProduct} setMenuOpen={setMenuOpen} />}
    </div>
  );
};

export default Menu;
